
export enum TemperatureProbeCategory {
    Supply,
    Return,
    Evaporator,
    Ambient
}
